
// Text processing utilities
export const MIN_WORD_COUNT = 25; // Minimum word count requirement

export const countWords = (text: string): number => {
  return text.trim().split(/\s+/).filter(Boolean).length;
};
